var map = {
	"./notifications-icon.png": "54b2",
	"./overview-icon.png": "586f",
	"./qrcode-icon.png": "bc3d",
	"./settings-icon.png": "d8d8",
	"./toggle-close.png": "4d8c",
	"./toggle-open.png": "44e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0642";